import React from 'react'

export default function SpotSnapMySpotsHistory() {
  return (
    <div>SpotSnapMySpotsHistory</div>
  )
}
